import React from "react";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/GenericFilterSort/OfferingsSortTab.scss";
import OfferingsRadioListFilters from "../OfferingsRadioListFilters/OfferingsRadioListFilters";
var OfferingsSortTab = function (props) {
    var _a;
    return (React.createElement("div", { className: "primary-offerings-sort-tab-container ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement(OfferingsRadioListFilters, { filterDataList: props.filterDataList, selectedRadioValue: props.selectedRadioValue, onChangeCallback: props.onChangeCallback })));
};
export default OfferingsSortTab;
